import { getPositionSource } from './positionSource';

/**
 * Una lectura puntual de posición, en promesa y por la fuente BUENA.
 *
 * ── Qué arregla ────────────────────────────────────────────────────────────
 *
 * La pestaña Ubicación llamaba a `navigator.geolocation.getCurrentPosition` a
 * pelo con `{ enableHighAccuracy: true }` y nada más. Eso se salta dos cosas:
 *
 *  1. El **tope**. `timeout` no puesto es, por especificación, infinito. Y este
 *     repositorio ya comprobó en vivo que `getCurrentPosition` **puede no llamar
 *     a ninguno de sus dos callbacks** con la red cortada (ver la nota de
 *     `PauseSurveillanceRouteModal`). Sin tope, el botón se queda esperando una
 *     respuesta que no llega nunca, sin error que mostrar.
 *  2. La **inyección de los tests E2E**, que pasan por `getPositionSource`.
 *
 * `getPositionSource().getCurrent` usa `WEB_ONE_SHOT_OPTIONS`
 * (`enableHighAccuracy`, `maximumAge: 0`, `timeout: 10000`), que es lo que ya
 * usa el hook cuando nadie le da la posición: así las dos entradas al botón se
 * comportan igual.
 *
 * Rechaza con la forma `{ code, message }` de la Geolocation API — `code === 1`
 * es PERMISSION_DENIED, la única negativa real del usuario.
 */
export function requestPositionOnce(): Promise<GeolocationPosition> {
  return new Promise<GeolocationPosition>((resolve, reject) => {
    const source = getPositionSource();
    if (!source) {
      reject({ code: 2, message: 'Geolocation no disponible' });
      return;
    }
    source.getCurrent(resolve, reject);
  });
}

export default requestPositionOnce;
